<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useCurrencyInput } from 'vue-currency-input'

// Input monetário no padrão brasileiro (R$ 1.234,56). v-model é o valor numérico
// (em reais). Reusa a lib vue-currency-input já presente no projeto.
const props = withDefaults(
  defineProps<{
    modelValue: number | null
    options?: Record<string, unknown>
  }>(),
  {
    modelValue: 0,
    options: () => ({ currency: 'BRL', locale: 'pt-BR', precision: 2, valueRange: { min: 0 } }),
  },
)

defineEmits(['update:modelValue'])

const { inputRef, setValue } = useCurrencyInput(props.options as any)

// Sincroniza o valor inicial e mudanças externas (ex.: recálculo da economia anual).
onMounted(() => setValue(props.modelValue ?? 0))
watch(
  () => props.modelValue,
  (value) => setValue(value ?? 0),
)
</script>

<template>
  <input ref="inputRef" type="text" inputmode="decimal" />
</template>
